// @ts-check
import { ref, onMounted } from 'vue'

export const setup = () => {
  const showAppHeader = ref(true)
  const isAndroid = ref(false)
  const isIOS = ref(false)
  const isPc = ref(false)
  const googleStoreUrl = 'https://play.google.com/store/apps/details?id=com.en_japan.iroots&pcampaignid=web_share'
  const appsStoreUrl =
    'https://apps.apple.com/jp/app/%E5%B0%B1%E6%B4%BB-%E3%81%AA%E3%82%89iroots-%E5%B0%B1%E6%B4%BB%E3%82%B5%E3%82%A4%E3%83%88%E3%81%AE%E5%B0%B1%E6%B4%BB%E3%82%A2%E3%83%97%E3%83%AA-%E3%82%B9%E3%82%AB%E3%82%A6%E3%83%88/id1479541565'

  const clickAppHeader = () => {
    showAppHeader.value = !showAppHeader.value
  }

  const clickDownloadButton = () => {
    if (isAndroid.value) {
      window.location.href = googleStoreUrl
    } else if (isIOS.value) {
      window.location.href = appsStoreUrl
    } else {
      // どちらでもない場合、処理なし（PCなど）
    }
  }

  onMounted(() => {
    const userAgent = window.navigator.userAgent.toLowerCase()
    isAndroid.value = userAgent.includes('android')
    isIOS.value = /iphone|ipad|ipod/.test(userAgent)
    isPc.value = !isAndroid.value && !isIOS.value
  })

  return {
    showAppHeader,
    isPc,
    clickAppHeader,
    clickDownloadButton,
  }
}
